<h2 mat-dialog-title>Select Asset</h2>

<div mat-dialog-content>
  <div *ngIf="loading" class="loading-spinner">
    <mat-spinner diameter="40"></mat-spinner>
  </div>

  <mat-form-field appearance="fill" *ngIf="!loading" class="full-width">
    <mat-label>Select an asset</mat-label>
    <mat-select [(value)]="selectedAssetId">
      <mat-option *ngFor="let asset of assets; trackBy: trackByAssetId" [value]="asset.id">
        {{ asset.name }} <span *ngIf="asset.type">({{ asset.type }})</span>
      </mat-option>
    </mat-select>
  </mat-form-field>

  <div *ngIf="!loading && assets.length === 0" class="no-assets-message">No assets available for selection.</div>
</div>

<div mat-dialog-actions align="end">
  <button mat-button (click)="onCancel()">Cancel</button>
  <button mat-raised-button color="primary" [disabled]="!selectedAssetId || loading" (click)="onConfirm()">
    Confirm
  </button>
</div>
